const Electronics = {
  categorys: "Top Electronics Aad More",
  Products: [
    {
      name: "TV",
      price: "$999",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/television/l/l/x/-original-imaghy7kyyr9pnrr.jpeg?q=70",
      company: "Sony And More",
    },
    {
      name: "Trimmer",
      price: "$999",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/trimmer/8/e/k/-original-imaghr3pajtxhvkk.jpeg?q=70",
      company: "Philips And More",
    },
    {
      name: "Camera",
      price: "$999",
      image:
        "https://rukminim1.flixcart.com/image/200/200/jfbfde80/camera/n/r/n/canon-eos-eos-3000d-dslr-original-imaf3t5h9yuyc5zu.jpeg?q=70",
      company: "Canon And More",
    },
    {
      name: "Phone",
      price: "$799",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/mobile/k/s/t/-original-imaghxengzjc2djt.jpeg?q=70",
      company: "Apple And More",
    },
    {
      name: "Laptop",
      price: "$1499",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/computer/q/e/z/-original-imagpxgqesgrthks.jpeg?q=70",
      company: "Dell And More",
    },
    {
      name: "Smartwatch",
      price: "$299",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/smartwatch/z/c/s/-original-imagp7vv3gwtnzhr.jpeg?q=70",
      company: "Samsung And More",
    },
    {
      name: "Headphones",
      price: "$199",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/headphone/p/0/p/-original-imagp6skfbnypq5g.jpeg?q=70",
      company: "Boat And More",
    },
    {
      name: "Tablet",
      price: "$599",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/tablet/d/d/n/-original-imaggp4gtdze4hfd.jpeg?q=70",
      company: "Microsoft And More",
    },
    {
      name: "Gaming Console",
      price: "$399",
      image:
        "https://rukminim1.flixcart.com/image/200/200/kffq2kw0/gamingconsole/d/4/q/setup-mobile-gaming-1-et-bazar-no-original-imafvvywbztpb8qt.jpeg?q=70",
      company: "Nintendo And More",
    },
    {
      name: "Smart Speaker",
      price: "$129",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/speaker/smart-speaker/i/z/m/bluetooth-speaker-boost-high-sound-blast-with-ultra-3d-bass-10-original-imagny3hbzftt2af.jpeg?q=70",
      company: "Amazon And More",
    },
  ],
};

const Fashion = {
  categorys: "Top FashionAnd More",
  Products: [
    {
      name: "T-Shirt",
      price: "$19.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/t-shirt/7/q/w/s-all-rbc-white-one-nb-nicky-boy-original-imagjz5bgpmhcaea.jpeg?q=70",
      category: "Men's Fashion",
      company: "Nike",
    },
    {
      name: "Jeans",
      price: "$39.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/jean/6/a/j/32-mss22mjn326-metronaut-original-imagq44r9qafse2a.jpeg?q=70",
      category: "Men's Fashion",
      company: "Levi's",
    },
    {
      name: "Dress",
      price: "$29.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/kurta/d/t/e/m-vm1026-vastramaniaa-original-imagnjvscze4zwdm.jpeg?q=70",
      category: "Women's Fashion",
      company: "Zara",
    },
    {
      name: "Shoes",
      price: "$49.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/shoe/q/r/j/-original-imagzjg25cg9wsrj.jpeg?q=70",
      category: "Women's Fashion",
      company: "Adidas",
    },
    {
      name: "Watch",
      price: "$99.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/watch/t/4/o/-original-imafumsmdjgbygtx.jpeg?q=70",
      category: "Accessories",
      company: "Fossil",
    },
    {
      name: "Sunglasses",
      price: "$29.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/l2ghgnk0/shopsy-sunglass/d/6/v/53-av102-srpm-original-imagdsuszf8wgssz.jpeg?q=70",
      category: "Accessories",
      company: "Ray-Ban",
    },
    {
      name: "Jacket",
      price: "$79.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/jacket/l/v/6/xl-mnt-7004-montrez-original-imagffv4bk5bkfpy-bb.jpeg?q=70",
      category: "Men's Fashion",
      company: "North Face",
    },
    {
      name: "Skirt",
      price: "$24.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/skirt/o/u/f/13-14-years-2-hd-55-hoda-original-imagpwdmfatf8f3m.jpeg?q=70",
      category: "Women's Fashion",
      company: "H&M",
    },
    {
      name: "Sweater",
      price: "$34.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/sweater/g/u/8/l-black-high-neck-b-fashlook-original-imagju9urdmaqaaz.jpeg?q=70",
      category: "Men's Fashion",
      company: "Gap",
    },
    {
      name: "Handbag",
      price: "$59.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/l2f20sw0/shopsy-hand-messenger-bag/b/4/n/stylish-women-shoulder-bag-shoper-1red-hobo-khatushyam-original-imagdrmucazmpztg.jpeg?q=70",
      category: "Accessories",
      company: "Coach",
    },
    {
      name: "Hat",
      price: "$14.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/kqidx8w0/hat/8/s/w/black-bucket-hat-free-1-b1-b1-handcuffs-original-imag4g8vygaduhem.jpeg?q=70",
      category: "Accessories",
      company: "New Era",
    },
    {
      name: "Shorts",
      price: "$29.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/kids-short/c/j/m/12-13-years-ct-shorts-race3-cute-trend-original-imafhpy8r66qxckm-bb.jpeg?q=70",
      category: "Men's Fashion",
      company: "Under Armour",
    },
    {
      name: "Blouse",
      price: "$39.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/l071d3k0/blouse/g/v/8/free-fnbgrey-samrat-export-original-imagcfndg8jhqhdf.jpeg?q=70",
      category: "Women's Fashion",
      company: "Forever 21",
    },
    {
      name: "Sneakers",
      price: "$69.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/shoe/c/d/i/7-95000215-41-roamra-white-original-imag4ahytjmqdzz8-bb.jpeg?q=70",
      category: "Men's Fashion",
      company: "Puma",
    },
    {
      name: "Necklace",
      price: "$49.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/krdtlzk0/jewellery-set/z/g/f/80035gr-saiyoni-original-imag56h7n7kk3tfv.jpeg?q=70",
      category: "Accessories",
      company: "Tiffany & Co.",
    },
    {
      name: "Pants",
      price: "$44.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/trouser/s/r/8/xl-jd-new-trou-rani-jaipur-global-original-imagjuc8pymk48wf.jpeg?q=70",
      category: "Men's Fashion",
      company: "Dockers",
    },
    {
      name: "Earrings",
      price: "$19.99",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/earring/h/y/8/na-fferv303-bx-gf-thrillz-original-imag9wsbhnd3yabc.jpeg?q=70",
      category: "Accessories",
      company: "Swarovski",
    },
  ],
};

const TVsAppliances = {
  categorys: "TV & Appliancesss  More",
  Products: [
    {
      name: "Smart TV",
      price: "$999",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/television/c/4/u/-original-imagkcdag59gr4dj.jpeg?q=70",
      category: "TV",
      company: "Samsung",
    },
    {
      name: "Refrigerator",
      price: "$799",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/refrigerator-new/4/q/7/-original-imagmxh2kv35bskc.jpeg?q=70",
      category: "Appliances",
      company: "LG",
    },
    {
      name: "Air Conditioner",
      price: "$699",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/air-conditioner-new/s/d/4/-original-imagnbf6mknssjhz.jpeg?q=70",
      category: "Appliances",
      company: "Daikin",
    },
    {
      name: "Washing Machine",
      price: "$599",
      image:
        "https://rukminim1.flixcart.com/image/200/200/l4zxn680/washing-machine-new/6/k/w/-original-imagfryzffszgvgm.jpeg?q=70",
      category: "Appliances",
      company: "Whirlpool",
    },
    {
      name: "Microwave Oven",
      price: "$199",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/microwave-new/r/j/z/-original-imagh59vgzghe2ca.jpeg?q=70",
      category: "Appliances",
      company: "Panasonic",
    },
    {
      name: "Vacuum Cleaner",
      price: "$149",
      image:
        "https://rukminim1.flixcart.com/image/200/200/k7285u80/vacuum-cleaner/h/j/f/agaro-rapid-1000-watt-10-litre-wet-dry-vacuum-cleaner-with-original-imafpd9kadgsmtds.jpeg?q=70",
      category: "Appliances",
      company: "Dyson",
    },
    {
      name: "Induction Cooktop",
      price: "$129",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/induction-cook-top/7/z/t/glass-7-preset-indian-menu-option-and-auto-shut-off-easy-cooking-original-imagn579xj5uryh5.jpeg?q=70",
      category: "Appliances",
      company: "Prestige",
    },
    {
      name: "Water Purifier",
      price: "$299",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/water-purifier/c/q/h/aqua-punch-kinsco-original-imaghhyvb9fkk3pq.jpeg?q=70",
      category: "Appliances",
      company: "Kent",
    },
    {
      name: "Blender",
      price: "$79",
      image:
        "https://rukminim1.flixcart.com/image/200/200/ktn9pjk0/hand-blender/f/c/k/4-in-1-stainless-steel-electric-blender-2-speed-blender-hand-original-imag6xyqmdfrmbwp.jpeg?q=70",
      category: "Appliances",
      company: "Hamilton Beach",
    },
    {
      name: "Electric Kettle",
      price: "$49",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/electric-kettle/p/f/l/-original-imaggx63nbajz9sh.jpeg?q=70",
      category: "Appliances",
      company: "Breville",
    },
    {
      name: "Toaster",
      price: "$39",
      image:
        "https://rukminim1.flixcart.com/image/200/200/kyvvtzk0/pop-up-toaster/i/y/b/33504-agaro-original-imagbyh32janv22c.jpeg?q=70",
      category: "Appliances",
      company: "Cuisinart",
    },
    {
      name: "Hair Dryer",
      price: "$29",
      image:
        "https://rukminim1.flixcart.com/image/200/200/xif0q/hair-dryer/c/c/d/professional-hair-dryer-1500-watts-and-hair-rolling-comb-original-imagpdh6reyjn8kt.jpeg?q=70",
      category: "Appliances",
      company: "Remington",
    },
    {
      name: "Iron",
      price: "$24",
      image:
        "https://rukminim1.flixcart.com/image/200/200/ksez24w0/iron/b/8/e/majesty-dx-6-bajaj-original-imag5zqbxnpua52a.jpeg?q=70",
      category: "Appliances",
      company: "Black+Decker",
    },
    {
      name: "Electric Shaver",
      price: "$149",
      image:
        "https://rukminim1.flixcart.com/image/200/200/l3lx8cw0/shaver/z/q/e/cet-175-shaver-3d-rechargeable-100-waterproof-ipx7-electric-original-imagezxyzzdmzzqw.jpeg?q=70",
      category: "Appliances",
      company: "Philips",
    },

    {
      name: "Rice Cooker",
      price: "$79",
      image:
        "https://rukminim1.flixcart.com/image/200/200/kuk4u4w0/electric-cooker/1/t/r/rcx-3-majesty-new-rcx-3-bajaj-original-imag7nxeft58dq6g.jpeg?q=70",
      category: "Appliances",
      company: "Bajaj",
    },
  ],
};

export { Electronics, Fashion, TVsAppliances };
